
export default {
  name: 'owner-bell-btn',
  data: function () {
    return { unread: 0 };
  },
  created: function () {
    this.$eventBus.$on('owner-unread', this.onUnread);
    this.$eventBus.$emit('owner-unread-query');
  },
  beforeDestroy: function () {
    this.$eventBus.$off('owner-unread', this.onUnread);
  },
  methods: {
    onUnread: function (n) {
      var v = Number(n);
      this.unread = isFinite(v) ? v : 0;
    },
    open: function () {
      this.$eventBus.$emit('owner-open-notices');
    }
  }
};
